
import { Component, Vue } from 'vue-property-decorator'
import { IReporterCollection } from '@/types/reporter-types'
import ReporterCollectionTable from './components/reporterCollectionTable.vue'
import AddReporterCollection from './components/addReporterCollection.vue'
import { ReporterService } from '@/services/index'

enum DialogStatus {
    ADD = 'add',
    EDIT = 'edit'
}

@Component({
    components: {
        ReporterCollectionTable,
        AddReporterCollection
    }
})
export default class extends Vue {
    private tableData: Array<IReporterCollection> = []
    private editIndex!: number
    private editRow: IReporterCollection | null = null
    private dialogStatus: string = DialogStatus.ADD
    private addPopover: boolean = false
    private pageIndex: number =  1
    private PageSize: number =  10
    private Total: number = 0
    private cloneObj: IReporterCollection | null = null
    private loading: any
    
    private mounted() {
        this.getCollectionList()
    }

    private async getCollectionList() {
        const params = {
            page_index: this.pageIndex,
            page_size: this.PageSize
        }
        const result = await ReporterService.getReportCollectionList(params)
        if (result.status === 200) {
            this.Total = result.data.page_total
            this.tableData = result.data.results
            this.closeLoading()
        }
    }

    // 点击创建集合按钮
    private createCollection(): void {
        this.dialogStatus = DialogStatus.ADD
        this.addPopover = true
    }

    // 关闭对话框
    private handleDialogClose(): void {
        this.addPopover = false
    }

    // 创建或者修改集合
    private handleSubmit(item: IReporterCollection) {
        // 显示 loading
        this.loading = this.$loading({
            lock: true,
            target: '.reporter-collection',
            text: this.dialogStatus === DialogStatus.ADD ? '创建中' : '修改中'
        })
        if (this.dialogStatus === DialogStatus.ADD) {
            // 新增集合
            this.addCollection(item)
        } else {
            // 修改集合
            this.updateCollection(item)
        }
    }

    private async addCollection(item: IReporterCollection) {
        // 创建集合
        const params = {
            cover_img: item.cover_img,
            name: item.name,
            order: item.order as number,
            memo: item.memo
        }
        const result = await ReporterService.addReporterCollection(params)
        if (result.status === 200 && result.data.id !== null) {
            this.$message({ showClose: true, message: '创建集合成功', type: 'success' })
            this.getCollectionList()
            return
        }
        this.closeLoading()
    }

    private async updateCollection(item: IReporterCollection) {
        // 对比修改项
        const params = {
            id: item.id!,
            cover_img: this.cloneObj!.cover_img === item.cover_img ? undefined : item.cover_img,
            name: this.cloneObj!.name === item.name ? undefined : item.name,
            order: this.cloneObj!.order === item.order ? undefined : item.order as number,
            memo: this.cloneObj!.memo === item.memo ? undefined : item.memo
        }
        // 修改集合
        const result = await ReporterService.updateReporterCollection(params)
        if (result.status === 200) {
            this.$message({ showClose: true, message: '集合修改成功', type: 'success' })
            this.getCollectionList()
            return
        }
        this.closeLoading()
    }

    // 编辑
    private handleCollectionEdit(item: IReporterCollection) {
        // 浅拷贝一个对象，用于后面作对比，是否需要发送参数
        this.cloneObj = JSON.parse(JSON.stringify(item))
        // 防止在对话框修改过程中，表格数据同步进行修改
        this.editRow = JSON.parse(JSON.stringify(item))
        this.dialogStatus = DialogStatus.EDIT
        this.addPopover = true
    }

    // 删除集合
    private handleCollectionRemove(id: number) {
        this.$confirm('你是否确定删除该集合?', '确定', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then( async () => {
            const params = { id }
            const result = await ReporterService.deleteReporterCollection(params)
            if (result.status === 200) {
                // 删除之后重新获取一次数据
                this.$message({
                    showClose: true,
                    type: 'success',
                    message: '删除成功'
                })
                const length = this.tableData.length
                this.pageIndex = length - 1 > 0 ? this.pageIndex : this.pageIndex - 1 
                this.getCollectionList()
            }
        })
    }

    // 当前页数改变
    private onCurrentPageChange(currPage: number) {
        this.pageIndex = currPage
        this.getCollectionList()
    }

    private closeLoading() {
        this.loading && this.loading.close()
    }
}
